import GuideDrawer from '@common/GuideDrawer'
import mainStore from '@components/Main/store'
import { TOP_BANNER_HEIGHT } from '@constant'
import { isNewOpen } from '@util'
import { Spin } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import Api from './api'
import CurrentGuide from './CurrentGuide'
import OtherCourseGuide from './OtherCourseGuide'

@observer
class CourseGuide extends Component {
  state = {
    loading: false,
    taskGuide: '',
    otherCourseGuide: undefined,
    status: undefined,
    visible: true
  }

  /**
   * 根据taskId变化判断是否需要重新请求右侧指导数据
   * 判断 otherGuide 前后是否有变化，来控制右侧栏的开启或关闭
   */
  componentDidUpdate(prevProps) {
    const { taskId: prevTaskId, otherGuide: prevOtherGuide } = prevProps
    const { taskId, otherGuide } = this.props

    if (prevTaskId !== taskId) {
      this._getCourseGuide()
    }

    if (prevOtherGuide !== otherGuide && otherGuide) {
      this.setState({
        visible: true
      })
    }
  }

  componentDidMount() {
    const { otherGuide } = this.props
    this._getCourseGuide()
    if (otherGuide) {
      this.setState({ visible: true })
    }
  }

  _getCourseGuide = async () => {
    this.setState({
      loading: true
    })
    const { taskId } = this.props
    const { data, success } = await Api.getCourseGuide({ taskId })
    if (success) {
      this.setState({
        status: data.status,
        taskGuide: data.taskGuide,
        otherCourseGuide: data.otherCourseGuide,
        loading: false,
        visible: true
      })
    }
  }

  render() {
    const { posterStore } = mainStore
    const { hasBannerPoster } = posterStore
    const { status, loading, taskGuide, otherCourseGuide, visible } = this.state
    const { otherGuide } = this.props

    const done = {
      // 请求完成
      query: status != null,
      // 该任务完成
      task: status === 3,
      // 全部任务都已完成
      allTask: otherCourseGuide && !otherCourseGuide.length,
      // 新手指南内容存在
      taskGuide: taskGuide != null
    }

    /**
     * 处于开店阶段商家显示逻辑：(otherGuide永远处于false，所以只会显示新手指南)
     * 1.处于开店阶段
     * 2.请求完成
     * 3.有taskGuide
     */

    /**
     * 不处于开店阶段商家显示逻辑：
     * 1.请求完成
     * 2.不处于开店阶段
     * 3.任务都未完成
     * 3.1.status !== 3 且 taskGuide有内容 且 otherGuide === false 时候显示新手指南
     * 3.2.otherGuide === true 且 otherCourseGuide[0].list 不为空数组 显示其他指南
     */
    const isShow = () => {
      if (isNewOpen()) {
        return done['query'] && done['taskGuide']
      } else {
        return (
          done['query'] &&
          !done['allTask'] &&
          ((!done['task'] && done['taskGuide'] && !otherGuide) ||
            otherGuideShow())
        )
      }
    }

    /**
     * 当otherGuide为true时
     * 需保证接口返回的otherCourseGuide的长度不为1的同时otherCourseGuide第一项下的list长度不为0
     * 否则otherGuide都不显示
     */
    const otherGuideShow = () =>
      otherGuide &&
      !(
        otherCourseGuide?.length === 1 &&
        otherCourseGuide?.[0]?.list?.length === 0
      )

    return (
      <>
        {isShow() ? (
          <GuideDrawer
            width={otherGuide ? 340 : 300}
            style={{
              top: hasBannerPoster ? TOP_BANNER_HEIGHT : 0,
              height: hasBannerPoster
                ? `calc(100% - ${TOP_BANNER_HEIGHT}px)`
                : '100%'
            }}
            visible={visible}
            onChange={e =>
              this.setState({
                visible: !e
              })
            }
            title={!otherGuide ? taskGuide?.title : '其他课程指导'}
            description={!otherGuide ? '' : '快速提升客资转化率'}
          >
            <Spin spinning={loading}>
              {!otherGuide && <CurrentGuide content={taskGuide?.content} />}
              {otherGuide && <OtherCourseGuide info={otherCourseGuide} />}
            </Spin>
          </GuideDrawer>
        ) : null}
      </>
    )
  }
}

export default CourseGuide
